'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../../icon/jsx/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // React component based on pp-vx design
// https://github.paypal.com/pages/PayPal-UI-R/pp-vx/#text-input


var componentClass = 'ppvx_text-input';

function Input(props) {
  var className = props.className,
      error = props.error,
      helper = props.helper,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      id = props.id,
      isValid = props.isValid,
      label = props.label,
      name = props.name,
      placeholder = props.placeholder,
      type = props.type,
      value = props.value,
      rest = _objectWithoutProperties(props, ['className', 'error', 'helper', 'leftIcon', 'rightIcon', 'id', 'isValid', 'label', 'name', 'placeholder', 'type', 'value']);

  var wrapperClassNames = (0, _classnames2.default)(className, 'ppvx_text-input', _defineProperty({
    'ppvx_field--error': !isValid
  }, componentClass + '--nolabel', !label));
  var msgId = 'msg_' + id;
  return _react2.default.createElement(
    'div',
    { className: wrapperClassNames },
    leftIcon && _react2.default.createElement(_Icon2.default, {
      className: componentClass + '__icon--left',
      name: leftIcon.name,
      size: 'xs',
      title: leftIcon.title
    }),
    rightIcon && _react2.default.createElement(_Icon2.default, {
      className: componentClass + '__icon--right',
      name: rightIcon.name,
      size: 'xs',
      title: rightIcon.title
    }),
    _react2.default.createElement('input', _extends({
      className: componentClass + '__control',
      id: id,
      name: name,
      placeholder: placeholder.text,
      type: type,
      value: value,
      'aria-describedby': msgId
    }, rest)),
    label && _react2.default.createElement(
      'label',
      { htmlFor: id, className: componentClass + '__label' },
      label.text
    ),
    !isValid && error ? _react2.default.createElement(
      'div',
      { className: componentClass + '__error-text', id: msgId },
      error.text
    ) : helper && _react2.default.createElement(
      'div',
      { className: componentClass + '__helper-text', id: msgId },
      helper.text
    )
  );
}

Input.propTypes = {
  className: _propTypes2.default.string,
  error: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  helper: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  leftIcon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  rightIcon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  id: _propTypes2.default.string.isRequired,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  name: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  type: _propTypes2.default.oneOf(['text', 'search', 'tel', 'email', 'url', 'number']),
  value: _propTypes2.default.string
};

Input.defaultProps = {
  className: '',
  error: {
    text: 'Please enter your name'
  },
  helper: {
    text: 'Enter the exact value that appear in your passport'
  },
  leftIcon: {
    name: 'ppvx_icon-info-alt',
    title: 'Information'
  },
  rightIcon: {
    name: 'ppvx_icon-search',
    title: 'Search'
  },
  isValid: true, // must be false for error message to show
  label: {
    text: 'First Name'
  },
  placeholder: {
    text: 'Enter your First Name'
  },
  type: 'text',
  value: undefined
};

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/forms/input/jsx/Input.js
// module id = 1064
// module chunks = 4